export default [
  {
    path: '/fashion/market',
    name: 'market',
    meta: {
      title: '市集'
    },
    component(resolve) {
      require(['COMPONENTS/fashion/market/main.vue'], resolve)
    }
  },
  {
    path: '/fashion/editCarousel',
    name: 'editCarousel',
    meta: {
      title: '轮播图管理页'
    },
    component(resolve) {
      require(['COMPONENTS/fashion/market/carousel/edit.vue'], resolve)
    }
  },
  {
    path: '/fashion/sideslip',
    name: 'sideslip',
    meta: {
      title: '横滑模块'
    },
    component(resolve) {
      require(['COMPONENTS/fashion/market/sideslip/main.vue'], resolve)
    }
  },
  {
    path: '/fashion/sideslipEdit',
    name: 'sideslipEdit',
    meta: {
      title: '横滑模块编辑'
    },
    component(resolve) {
      require(['COMPONENTS/fashion/market/sideslip/edit.vue'], resolve)
    }
  },
  {
    path: '/fashion/hotMapEdit',
    name: 'hotMapEdit',
    meta: {
      title: '热区图编辑'
    },
    component(resolve) {
      require(['COMPONENTS/fashion/market/hotMap/edit.vue'], resolve)
    }
  },
  {
    path: '/fashion/discovery',
    name: 'discovery',
    meta: {
      title: '发现'
    },
    component(resolve) {
      require(['COMPONENTS/fashion/discovery/main.vue'], resolve)
    }
  },
]